// extracted by mini-css-extract-plugin
export var displayNone = "_nz-6";
export var imgContainer = "_nz-2";
export var overflowHidden = "_nz-3";
export var productInfoCardButtonContainer = "_nz-5";
export var productTitleText = "_nz-4";
export var rightArrow = "_nz-1";
export var rightArrowContainer = "_nz-0";